import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getTicketsusuario } from '../services/apis';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const formatoEuro = (valor) => Number(valor || 0).toLocaleString('ca-ES', {
    style: 'currency',
    currency: 'EUR'
});

export const TicketsUsuario = ({ year = new Date().getFullYear() }) => {
    const [loaded, setLoaded] = useState(false);
    const [ticketsUsuario, setTicketsusuario] = useState([]);
    const [ticketsEventos, setTicketsEventos] = useState([]);

    const getToneClass = (cantidad) => {
        if (cantidad < 0) {
            return 'ticket-amount-negative';
        }

        if (cantidad > 0) {
            return 'ticket-amount-positive';
        }

        return 'ticket-amount-neutral';
    };

    const cargarTicketsusuario = async () => {
        try {
            const response = await getTicketsusuario(year);

            if (response.success) {
                setTicketsusuario(response.data);
                setTicketsEventos(response.eventos || []);
                setLoaded(true);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        setLoaded(false);
        cargarTicketsusuario();
    }, [year]);

    if (!loaded || ticketsUsuario.length === 0) {
        if (!loaded || ticketsEventos.length === 0) return null;
    }

    return (
        <Box className="side-ticket-card">
            <Typography className="side-widget-title">
                Els teus tiquets
            </Typography>

            <Stack className="side-ticket-list">
                {ticketsUsuario.map((info) => (
                    <Box key={info.nombre} className="side-ticket-row">
                        <Typography className="side-ticket-name">
                            {info.nombre}
                        </Typography>
                        <Stack alignItems="flex-end" spacing={0.25}>
                            <Typography className={`side-ticket-amount ${getToneClass(Number(info.cantidad))}`}>
                                {info.cantidad} ({formatoEuro(info.total_euros)})
                            </Typography>
                            <Typography variant="caption" color="success.main">Pagat: {formatoEuro(info.total_pagado)}</Typography>
                            <Typography variant="caption" color="warning.dark">Pendent: {formatoEuro(info.total_pendiente)}</Typography>
                        </Stack>
                    </Box>
                ))}
            </Stack>

            {ticketsEventos.length > 0 && (
                <Accordion elevation={0} className="side-ticket-events">
                    <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
                        <Typography className="side-ticket-name">Tiquets per esdeveniment</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack spacing={1}>
                            {Object.values(ticketsEventos.reduce((grupos, ticket) => {
                                const id = ticket.id_evento;
                                if (!grupos[id]) grupos[id] = { ...ticket, tickets: [] };
                                grupos[id].tickets.push(ticket);
                                return grupos;
                            }, {})).map((evento) => (
                                <Box key={evento.id_evento} className="side-ticket-event">
                                    <Typography className="side-ticket-name">{evento.evento}</Typography>
                                    <Typography variant="caption">{evento.fecha}</Typography>
                                    {evento.tickets.map((ticket) => (
                                        <Box key={`${ticket.ticket}-${ticket.pagado}`} className="side-ticket-row">
                                            <Typography variant="caption">{ticket.ticket} × {ticket.cantidad}</Typography>
                                            <Stack alignItems="flex-end" spacing={0.25}>
                                                <Typography variant="caption">{formatoEuro(ticket.total_euros)}</Typography>
                                                <Typography variant="caption" color={Number(ticket.pagado) === 1 ? 'success.main' : 'warning.dark'}>
                                                    {Number(ticket.pagado) === 1 ? 'Pagat' : 'Pendent'}
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                        </Stack>
                    </AccordionDetails>
                </Accordion>
            )}
        </Box>
    );
};
